export const IChat = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
    <path d="M14 8A6 6 0 112.6 10.9L2 14l3.1-.6A6 6 0 0014 8z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
  </svg>
);
